<template>
    
    <div class="w-full h-10 pl-4 flex bg-white rounded-lg border border-solid border-gray-600 overflow-hidden" >

        <img src="/images/icons/search.svg" alt="search" >

        <input 
        
        type="text"
        placeholder="Eg: Animal Name/Number"
        class="text-sm pl-4 outline-none w-full h-full border-0 bg-transparent"  
        
        v-model="search" 
        
        >

        <div 
        
        class="w-12 bg-blue-900 flex items-center justify-center cursor-pointer" 
        
        v-if="search"

        @click="search = ''"
        
        >

            <img src="/images/icons/close.svg" alt="close" >

        </div>

    </div>

</template>

<script>

    import { useStore } from 'vuex'
    import { computed } from 'vue'
    
    export default {
    
        name: 'Searchbar',

        setup() {

            const store = useStore()

            const search = computed({

                get: () => store.state.search,
                set: val => store.commit( 'setSearch', val )

            })

            return {
                search
            }

        }

    }

</script>